module.exports = __webpack_public_path__ + "img/icon02.9b1809fd.png";